// Which kind of instrument produced a survey, for presentation only.
//
// There is no survey-type field: DeviceType is 0 for MiNS, AQ Gyro and CoreTrak
// alike, so the tool class is read from DeviceName, which the app stamps on every
// upload. Orientation maths and QA never key on this — they route on the
// calibration's shape — so a CoreTrak survey still gets AQ's treatment.
// Mirrors Services/SurveyClass.cs. New CoreTrak views should call this rather
// than compare the name themselves.

export const CORETRAK_NAME = 'CoreTrak';

// A core-orientation run: one shot per run, so a hole's trajectory is assembled
// from many runs (POST api/surveys/composite) rather than read off any one.
export function isCoreTrakSurvey(survey) {
    return !!survey && (survey.DeviceName || '').startsWith(CORETRAK_NAME);
}
